import React from 'react';
import Promise from 'bluebird';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import FacebookBtn from 'components/facebookBtn';
import {
  validEmail,
  validMobile,
  validDate,
  underage,
  formatBirthday,
  displayBirthday
} from 'shared/models/user';
import FormField from 'shared/components/ui/formField';
import Button from 'shared/components/ui/button';
import View from 'shared/components/ui/view';
import Text from 'shared/components/ui/text';
import Experiment from 'shared/components/experiment';
import Variant from 'shared/components/experiment/variant';
import { trackNow } from 'shared/models/analytic';

const SOURCE_OPTIONS = [
  'Website / Blog',
  'Radio / Podcast',
  'Social Media',
  'Friends',
  'Search',
  'On a Train or Billboard'
];

let SignupForm = class SignupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: {},
      error: null,
      fbLoading: false,
      source: '',
      isGuest: false
    };
    this.setModel(props.user);
  }

  componentWillMount() {
    this.sourceOptions = _.shuffle(SOURCE_OPTIONS)
      .concat('Other')
      .map(option => ({ value: option, label: option }));
  }

  setModel(params) {
    this.model = {
      firstname: params.firstname,
      lastname: params.lastname,
      birthday: params.birthday,
      email: params.email,
      mobile: params.mobile,
      password: params.password
    };
  }

  setFBLoading() {
    this.setState({ fbLoading: true });
  }

  setFBUser(user) {
    this.setModel(user.attributes);
    this.setState({ fbLoading: false });
  }

  handleFBSignup(user) {
    this.setFBUser(user);
    if (this.props.onFBSignup) {
      return this.validateFields()
        .then(() => this.props.onFBSignup())
        .catch(({ message }) => {
          this.setState({ loading: false, error: message });
        });
    }
  }

  handleFBLogin(user) {
    this.setFBUser(user);
    if (this.props.onFBLogin) {
      return this.props.onFBLogin().catch(({ message }) => {
        this.setState({ loading: false, error: message });
      });
    } else if (this.props.onSuccess) {
      return this.props.onSuccess();
    }
  }

  validateFirstname(name) {
    if (_.isEmpty(name)) return "First Name can't be blank";
  }

  validateLastname(name) {
    if (_.isEmpty(name)) return "Last Name can't be blank";
  }

  validateBirthday(birthday) {
    if (!validDate(birthday))
      return 'Birthday is not a valid date (mm/dd/yyyy)';
    if (underage(birthday)) return 'You must be 21 or older';
  }

  validateEmail(email) {
    if (!validEmail(email)) return 'Email is not valid';
  }

  validateMobile(number) {
    if (!validMobile(number)) return 'Mobile number is not valid';
  }

  validatePassword(password) {
    if (!password) return "Password can't be blank";
    if (password.length < 6) return 'Password must be at least 6 characters';
  }

  validateFields() {
    const {
      firstname,
      lastname,
      email,
      mobile,
      birthday,
      password
    } = this.model;

    let errors = {};
    errors.firstname = this.validateFirstname(firstname) || null;
    errors.lastname = this.validateLastname(lastname) || null;
    errors.email = this.validateEmail(email) || null;
    if (!this.props.hideMobile)
      errors.mobile = this.validateMobile(mobile) || null;
    errors.birthday = this.validateBirthday(birthday) || null;
    if (!this.props.user.objectId)
      errors.password = this.validatePassword(password) || null;

    this.setState({ errors });

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  _submit() {
    const data = {
      ...this.model,
      firstname: this.model.firstname.trim(),
      lastname: this.model.lastname.trim(),
      email: this.model.email.trim(),
      birthday: formatBirthday(this.model.birthday)
    };

    if (!this.props.hideMobile) data.mobile = this.model.mobile.trim();
    if (this.state.source) data.stated_source = this.state.source.value;

    return this.props.onSubmit(data).catch(e => Promise.reject(e));
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, error: null });
    this.validateFields()
      .then(() => this._submit())
      .then(() => {
        this.setState({ loading: false, error: null });
        if (this.props.checkout)
          trackNow('Checkout Sign Up', { guest: this.state.isGuest });
        this.props.onSuccess && this.props.onSuccess();
      })
      .catch(({ message }) => {
        this.setState({ loading: false, error: message });
      });
  }

  render() {
    const user = this.props.user;
    const compact = this.props.compact;
    const showMobile = !this.props.hideMobile;
    const showPromo = !!this.props.onPromoChange;

    return (
      <div className="text-left">
        {!user.objectId &&
          !this.state.fbLoading && (
            <View margin="sm">
              <FacebookBtn
                className="btn--full-width"
                text="Continue with Facebook"
                onLoading={() => this.setFBLoading()}
                onComplete={user => this.handleFBSignup(user)}
                onLogin={user => this.handleFBLogin(user)}
                promoCode={this.props.promoCode}
              />
            </View>
          )}

        {!user.objectId &&
          !this.state.fbLoading && (
            <View margin="sm">
              <div className="divider-group">
                <div className="divider-group__text">OR</div>
                <div className="divider-group__divider" />
              </div>
            </View>
          )}

        {this.state.fbLoading && (
          <div className="loading-spinner-container">
            <LoadingSpinner green />
          </div>
        )}

        <form onSubmit={e => this.handleSubmit(e)}>
          {this.state.error && (
            <div className="warning">{this.state.error}</div>
          )}

          {this.props.checkout && (
            <Experiment name="Guest Checkout" defaultVariant="Null">
              <Variant name="Null">{''}</Variant>
              <Variant name="Show Checkbox">
                <div className="row">
                  <View margin="sm" className="col-xs-12 col-md-6">
                    <label htmlFor="guestCheckout" className="clickable">
                      <input
                        type="checkbox"
                        id="guestCheckout"
                        name="guestCheckout"
                        checked={this.state.isGuest}
                        onChange={() =>
                          this.setState(state => ({ isGuest: !state.isGuest }))}
                      />
                      <View inlineBlock padding={{ sides: 'xs' }}>
                        <Text tag="span" secondary>
                          Checkout as guest
                        </Text>
                      </View>
                    </label>
                  </View>
                </div>
              </Variant>
            </Experiment>
          )}

          <div className="row">
            <div className={compact ? 'col-xs-6' : 'col-xs-12 col-md-6'}>
              <FormField
                id="user-first-name"
                name="fname"
                labelText="First Name"
                initialValue={user.firstname}
                updatedValue={user.firstname}
                onChange={firstname =>
                  (this.model = { ...this.model, firstname })}
                validate={firstname => this.validateFirstname(firstname)}
                error={this.state.errors.firstname}
              />
            </div>

            <div className={compact ? 'col-xs-6' : 'col-xs-12 col-md-6'}>
              <FormField
                id="user-last-name"
                name="lname"
                labelText="Last Name"
                initialValue={user.lastname}
                updatedValue={user.lastname}
                onChange={lastname =>
                  (this.model = { ...this.model, lastname })}
                validate={lastname => this.validateLastname(lastname)}
                error={this.state.errors.lastname}
              />
            </div>

            <div className="col-xs-12">
              <FormField
                id="user-birthday"
                name="birthday"
                labelText="Birthday"
                placeholder="mm/dd/yyyy"
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]}
                inputType="tel"
                initialValue={displayBirthday(user.birthday)}
                updatedValue={displayBirthday(user.birthday)}
                onChange={birthday =>
                  (this.model = { ...this.model, birthday })}
                validate={birthday => this.validateBirthday(birthday)}
                error={this.state.errors.birthday}
              />
            </div>

            <div className="col-xs-12">
              <FormField
                id="user-email"
                name="email"
                labelText="Email"
                inputType="email"
                autocomplete="username email"
                initialValue={user.email}
                updatedValue={user.email}
                onChange={email => (this.model = { ...this.model, email })}
                validate={email => this.validateEmail(email)}
                error={this.state.errors.email}
              />
            </div>

            {showMobile && (
              <div className="col-xs-12">
                <FormField
                  id="user-mobile"
                  name="phone"
                  labelText="Mobile No."
                  inputType="tel"
                  autocomplete="mobile tel"
                  initialValue={user.mobile}
                  updatedValue={user.mobile}
                  onChange={mobile => (this.model = { ...this.model, mobile })}
                  validate={mobile => this.validateMobile(mobile)}
                  error={this.state.errors.mobile}
                />
              </div>
            )}

            {!user.objectId && (
              <div className="col-xs-12">
                <FormField
                  id="user-password"
                  name="password"
                  labelText="Password (min. 6 characters)"
                  inputType="password"
                  autocomplete="new-password"
                  onChange={password =>
                    (this.model = { ...this.model, password })}
                  validate={password => this.validatePassword(password)}
                  error={this.state.errors.password}
                />
              </div>
            )}

            {showPromo && (
              <div className="col-xs-12">
                <FormField
                  id="user-promo"
                  name="promo"
                  labelText="Promo Code or Gift Card (optional)"
                  initialValue={this.props.promo}
                  updatedValue={this.props.promo}
                  onChange={this.props.onPromoChange}
                />
              </div>
            )}

            <div className="col-xs-12">
              <Select
                instanceId="user-source"
                id="user-source"
                name="source"
                className="form-field"
                placeholder="How did you hear about Saucey? (optional)"
                value={this.state.source}
                options={this.sourceOptions}
                onChange={source => this.setState({ source })}
                scrollMenuIntoView={false}
                searchable={false}
                onSuggestionsFetchRequested={this.noop}
                onSuggestionsClearRequested={this.noop}
              />
            </div>
          </div>

          <div className="row center-xs start-md middle-md">
            <div className="col-xs-12 col-md-7 col-lg-8">
              <View margin="sm">
                <small>
                  <span>By continuing you agree to the </span>
                  <a
                    href="/terms-of-service"
                    target="_blank"
                    className="link-text"
                  >
                    Terms of Service
                  </a>
                  <span> & </span>
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    className="link-text"
                  >
                    Privacy Policy
                  </a>
                </small>
              </View>
            </div>

            <div className="col-xs-12 col-md-5 col-lg-4">
              <Button
                type="submit"
                className="btn-primary green btn--full-width"
                disabled={this.state.loading || this.state.fbLoading}
                loading={this.state.loading || this.props.loading}
              >
                Continue
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

SignupForm = connect(
  state => ({
    user: state.login.user || {}
  }),
  {}
)(SignupForm);

export default SignupForm;



// WEBPACK FOOTER //
// ./shared/components/login/signup.js